import React from 'react';
import { IconButton, ToggleButtonGroup, Tooltip } from '@mui/joy';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';

const ViewToggle = ({ value, onChange }) => {
  return (
    <ToggleButtonGroup
      size="sm"
      value={value}
      onChange={(_, newValue) => newValue && onChange(newValue)}
      sx={{
        '--ButtonGroup-separatorColor': 'transparent',
      }}
    >
      <Tooltip title="Grid view">
        <IconButton value="grid" variant={value === 'grid' ? 'solid' : 'outlined'}>
          <GridViewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="List view">
        <IconButton value="list" variant={value === 'list' ? 'solid' : 'outlined'}>
          <ViewListIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default ViewToggle;
